import React from 'react';
import styles from '../OrderStatus.module.css';
import { useStates } from '../../../hooks/StatesContext';

const ShippingDetails = (props) => {

  const states = useStates();
  const [stateAbbreviation, setStateAbbreviation] = React.useState('');

  React.useEffect(() => {
    if (states.length > 0) {
      setStateAbbreviation(states.find(state => state.state_id === props.order.purchase_ship_state_id).state_abbreviation);
    }
  }, [states]);

  function buildTrackingNumberURL(trackingNumber) {
    if (trackingNumber.tracking_service == 'UPS') {
      return 'http://wwwapps.ups.com/WebTracking/processInputRequest?loc=en_US&amp;tracknum=' + trackingNumber.tracking_number;
    } else if (trackingNumber.tracking_service == 'FedEx') {
      return 'https://www.fedex.com/apps/fedextrack/?tracknumbers=' + trackingNumber.tracking_number;
    } else {
      return '';
    }
  }

  return (
    <>
      <h2 className={styles.heading}>SHIPPING INFORMATION</h2>
      <p>{props.order.purchase_ship_contact}</p>
      <p>{props.order.purchase_ship_address_1}</p>
      <p>{props.order.purchase_ship_city + ', ' + stateAbbreviation + ' ' + props.order.purchase_ship_zip}</p>
      <p><strong><br />Tracking Numbers:</strong></p>
      {props.trackingNumbers?.map((trackingNumber) => {
        return (
          <p key={trackingNumber.tracking_number}>{trackingNumber.tracking_date} - {trackingNumber.tracking_service}: <a target='_blank' href={buildTrackingNumberURL(trackingNumber)}>{trackingNumber.tracking_number}</a></p>
        );
      })}
    </>
  );
};

export default ShippingDetails;